import * as HttpService from "../../../../service/HttpService";


/**用能计划 查询树方法 */
export const queryTree = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/queryTree", params);
};

/**查询用能计划 */

export const getPlanData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/queryData", params);
};


/**用能计划新增 */
export const addPlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/addPlan", params);
};
/** 用能计划  根据已选择的树  查询有几个用能点 */
export const findTreePoint = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/findTreePoint", params);
};

/**用能计划编辑 */
export const editPlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/editPlan", params);
};
/**用能计划删除 */
export const delPlan = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/mgmt_planning/delPlan", params);
};


/** 管控收益查询 */

export const getProfitData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/esMgmtOutPlanEventStat/queryData", params);
};


/** 意外处置查询 */

export const getManagementData = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/outPlanEvent/queryData", params);
};

/**  意外处置的编辑（管理执行） */
export const editProcessed = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/outPlanEvent/editProcessed", params);
};

/*查询巡视部门 */
export const getSysDept = () => {
    return HttpService.post(HttpService.DOMAIN + "/patrolManagement/getSysDept", );
};


/*查询巡视人员 */
export const getBySysUser = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/outPlanEvent/getBySysUser", params);
};

/**控制开关的方法 **/
export const setSwitchSetting = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/jalasmart/setSwitchSetting", params);
};






